import React from "react";
import { loadFieldsPP } from "../formFields/shippmentTabsFields";
import GenericFormTab from "./GenericFormTab"; // adjust path

export default function LoadTab({ formData, onChange  , errors = {} , viewOnly = false , isEdit = true }) {
    const disableLoad = !isEdit || viewOnly;
    return <GenericFormTab fields={loadFieldsPP} formData={formData} onChange={onChange} errors={errors} readOnly={disableLoad} isEdit={isEdit} />;
}
